import { Routes } from '@angular/router';
import { LostMfaEmailSentComponent } from 'projects/login/src/app/pages/lost-mfa/lost-mfa-email-sent/lost-mfa-email-sent.component';
import { LostMfaTriggerComponent } from 'projects/login/src/app/pages/lost-mfa/lost-mfa-trigger/lost-mfa-trigger.component';
import { LostMfaVerifyComponent } from 'projects/login/src/app/pages/lost-mfa/lost-mfa-verify/lost-mfa-verify.component';
import { LogoutComponent } from 'projects/login/src/app/pages/logout/logout.component';
import { LostMfaComponent } from 'projects/login/src/app/pages/lost-mfa/lost-mfa.component';
import { AuthGuard } from 'projects/login/src/app/services/has-session.guard';
import { ActivationLayoutComponent } from './layout/activation-layout/activation-layout.component';
import { LoginLayoutComponent } from './layout/login-layout/login-layout.component';
import { ActFinishedComponent } from './pages/activation/act-finished/act-finished.component';
import { ActSetPasswordComponent } from './pages/activation/act-set-password/act-set-password.component';
import { ActSetupTwoFactorAuthComponent } from './pages/activation/act-setup-two-factor-auth/act-setup-two-factor-auth.component';
import { PasswordResetPageComponent } from './pages/forgot-password/password-reset-page/password-reset-page.component';
import { ResetPasswordComponent } from './pages/forgot-password/reset-password/reset-password.component';
import { ResetRequestedComponent } from './pages/forgot-password/reset-requested/reset-requested.component';
import { LoginPageComponent } from './pages/regular-login/login-page/login-page.component';
import { TwoFactorAuthenticationPageComponent } from './pages/regular-login/two-factor-authentication/two-factor-authentication-page.component';
import { TwoFactorSetupComponent } from './pages/regular-login/two-factor-setup/two-factor-setup.component';
import { LayoutPageResolverService } from './services/layout-page-resolver/layout-page-resolver.service';
import { authGuard } from './utils/guards/auth-guard';

export const routes: Routes = [
  {
    path: '',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        component: LoginPageComponent,
        canActivate: [AuthGuard],
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'login-page.header.name',
        },
      },
      {
        path: 'email-verify',
        data: { title: 'email-verify-page.header.name' },
        loadComponent: () => import('./pages/email-verification/email-verification.component').then((module) => module.EmailVerificationComponent),
      },
      {
        data: { title: 'page.title.errors' },
        path: 'error',
        loadComponent: () => import('./pages/error-page/error-page.component').then((module) => module.ErrorPageComponent),
      },
      {
        data: { title: 'page.title.errors' },
        path: 'session-error',
        loadComponent: () =>
          import('./pages/regular-login/login-session-expired/login-session-expired.component').then((module) => module.LoginSessionExpiredComponent),
      },
      {
        data: { title: 'page.title.errors' },
        path: 'invalid-session',
        loadComponent: () => import('./pages/error-page/no-session-page/no-session-page.component').then((module) => module.NoSessionPageComponent),
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
        canActivate: [AuthGuard],
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'reset-password.header.name',
        },
      },
      {
        path: 'password-reset',
        component: PasswordResetPageComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'password-reset.header.name',
        },
      },
      {
        path: 'reset-requested',
        canActivate: [AuthGuard],
        component: ResetRequestedComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'reset-requested.header.name',
        },
      },
      {
        path: 'lost-2fa',
        component: LostMfaComponent,
        canActivate: [AuthGuard],
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'lost-2fa.header.name',
        },
      },
      {
        path: 'lost-2fa-email',
        component: LostMfaEmailSentComponent,
        canActivate: [AuthGuard],
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'lost-2fa.header.name',
        },
      },
      {
        path: 'lost-2fa-trigger',
        component: LostMfaTriggerComponent,
        canActivate: [AuthGuard],
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'lost-2fa-trigger.header.name',
        },
      },
      {
        path: 'lost-2fa-verify',
        component: LostMfaVerifyComponent,
        canActivate: [AuthGuard],
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'lost-2fa-verify.header.name',
        },
      },
      {
        canActivate: [authGuard],
        path: 'two-factor-authentication',
        component: TwoFactorAuthenticationPageComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'login-page.header.name',
        },
      },
      {
        canActivate: [authGuard],
        path: 'authentication-setup',
        component: TwoFactorSetupComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'authentication-setup-page.header.name',
        },
      },
    ],
  },
  {
    path: 'activation',
    component: ActivationLayoutComponent,
    children: [
      {
        path: '',
        component: ActSetPasswordComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'activation.change-password-page.header.name',
        },
      },
      {
        path: 'setup-2fa',
        component: ActSetupTwoFactorAuthComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'activation.setup-2fa-page.header.name',
        },
      },
      {
        path: 'finished',
        component: ActFinishedComponent,
        resolve: { layoutPageName: LayoutPageResolverService },
        data: {
          headerName: 'activation.finished-page.header.name',
        },
      },
    ],
  },
  {
    path: 'logged-out',
    component: LogoutComponent,
    resolve: { layoutPageName: LayoutPageResolverService },
    data: {
      headerName: 'logout.header.name',
    },
  },
  {
    path: '**',
    redirectTo: '',
  },
];
